export default __webpack_public_path__ + "static/media/businessman-using-pen-planning-financial-strategy-tablet-with-dashboard (1).e98020f3.jpg";